import Filter from '../filter/filter';
import request from 'oc-request'

export default new (class Pagination {
    constructor() {
        this.paginationContainer = "_pagination"
        this.paginationBtn = "_pagination-item"
        this.paginationActive = "_pagination-item--active"

        this.handler()
    }

    handler() {
        const paginationContainer = document.querySelector(`.${this.paginationContainer}`)

        if (!paginationContainer) return

        document.addEventListener("DOMContentLoaded", () => {
            this.init()
        })
    }

    init() {
        document.querySelectorAll(`.${this.paginationBtn}`).forEach((item) => {
            item.addEventListener('click', (obEvent) => {
                obEvent.preventDefault()
                let _this = this;
                let page = obEvent.target.getAttribute('data-page');
                if(page == undefined) {
                    page = obEvent.target.closest(`.${this.paginationBtn}`).getAttribute('data-page')
                }
                //листинг товаров
                if(document.querySelector('#_category-product-list')) {
                    document.querySelector('#_category-product-list').classList.add('_preloader');
                    let sort = document.querySelector(`.${Filter.filterSortingBtn} .select__input`).getAttribute('value')
                    request.sendData('ProductList::onAjaxRequest', {
                        data: {
                            page,
                            sort
                        },
                        update: {
                            'category-product-list/category-product-list':'#_category-product-list',
                            'pagination/pagination':'._pagination'
                        },
                        complete: function() {
                            document.querySelector('#_category-product-list').classList.remove('_preloader');
                            _this.init()
                        }
                    });
                }
                //листинг проектов
                if(document.querySelector('#_projects-list')) {
                    document.querySelector('#_projects-list').classList.add('_preloader');
                    let categoryId = [];
                    document.querySelectorAll('[data-burger-select="filter"] input').forEach((element, index) => {
                        if(element.checked) {
                            categoryId.push(element.value)
                        }
                    });

                    request.sendData('StsProjectList::onAjaxRequest', {
                        data: {
                            page,
                            categoryId,
                        },
                        update: {
                            'projects-list/projects-list':'#_projects-list',
                            'pagination/pagination':'._pagination'
                        },
                        complete: function() {
                            document.querySelector('#_projects-list').classList.remove('_preloader');
                            _this.init()
                        }
                    });
                }
                //листинг постов
                if(document.querySelector('#_articles-list')) {
                    document.querySelector('#_articles-list').classList.add('_preloader');
                    let categoryId = [];
                    document.querySelectorAll('[data-burger-select="filter"] input').forEach((element, index) => {
                        if(element.checked) {
                            categoryId.push(element.value)
                        }
                    });

                    request.sendData('ArticleList::onAjaxRequest', {
                        data: {
                            page,
                            categoryId,
                        },
                        update: {
                            'articles-list/articles-list':'#_articles-list',
                            'pagination/pagination':'._pagination'
                        },
                        complete: function() {
                            document.querySelector('#_articles-list').classList.remove('_preloader');
                            _this.init()
                        }
                    });
                }
            })
        });
    }
})()
